import { toast } from "react-toastify";

class ToastClass {

    Show(type: "success" | "error" | "info", message: string) {

        toast.dismiss();
        toast(message, {
            type,
            theme: "colored",
            style: { whiteSpace: "pre-line" }
        });
    }
}

var Toast = new ToastClass();
export default Toast;